export const AUTH_PATH = "auth";
export const ADMIN_PATH = "admin";
export const USER_PATH = "user";
export const DRUG_PATH = "drug";
export const NOTI_CAMPAIGN_PATH = "campaign";
